import { Link } from "react-router-dom";
import { ArrowLeft, Layers } from "lucide-react";
import SocratesAvatar, { characterForAgent } from "@/components/SocratesAvatar";
import { NOMBRE_DEL_MENTOR } from "@/data/agents";
import { colorDeLaCompetencia } from "@/lib/competencias.mjs";

const BOTON = "w-11 h-11 flex-shrink-0 inline-flex items-center justify-center rounded-full text-alpha-black/70 hover:bg-alpha-black/5";

/**
 * Quién te está dando la lección: su cara, su nombre y si está escribiendo. Y a los lados, como en
 * WhatsApp, lo único que se puede hacer sin salir del chat: volver y las tarjetas. Las dos
 * son opcionales: la lección de prueba de la portada no tiene ninguna.
 */
export default function CabeceraDeMentor({ ficha, busy, phase, volver, tarjetas = 0, onTarjetas }) {
  return (
    <div className="flex items-center gap-2 sm:gap-3 px-2 sm:px-5 py-2 sm:py-3 bg-white/70 border-b border-alpha-black/5 backdrop-blur flex-shrink-0">
      {volver && (
        <Link to={volver} className={BOTON} aria-label="Volver al curso" data-testid="lesson-back">
          <ArrowLeft className="w-5 h-5" />
        </Link>
      )}
      <div className="w-11 h-11 flex-shrink-0">
        <SocratesAvatar
          character={characterForAgent(ficha?.agentKey)}
          mood={busy ? "thinking" : phase === "done" ? "happy" : "idle"}
          size={44}
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-serif-display text-lg leading-none">
          {NOMBRE_DEL_MENTOR[ficha?.agentKey] || "Sócrates"}
        </div>
        <div className={`text-[10px] font-mono-alpha uppercase tracking-widest ${colorDeLaCompetencia(ficha?.agentKey).rotulo} mt-1`}>
          {busy ? "Escribiendo…" : "En directo"}
        </div>
      </div>
      {tarjetas > 0 && onTarjetas && (
        <button type="button" onClick={onTarjetas} className={BOTON} aria-label={`Abrir las ${tarjetas} tarjetas de memoria`} data-testid="flashcards-open">
          <Layers className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
